import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { dragscroll } from 'vue-dragscroll';
import { usePinchZoom, useScrollZoom } from '~/core/composables';
import { usePDFJS, usePDFSize } from './composables';
import PDFViewPage from './PDFViewerPage.vue';
export default defineComponent({
  name: 'PDFViewer',
  components: {
    PDFViewPage: PDFViewPage
  },
  directives: {
    dragscroll: dragscroll
  },
  props: {
    src: {
      type: String,
      required: true
    },
    isScaled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  setup: function setup(props, _ref) {
    var expose = _ref.expose;
    var refProps = toRefs(props);
    var _usePDFJS = usePDFJS(),
      load = _usePDFJS.load,
      pdf = _usePDFJS.pdf,
      destroyPDF = _usePDFJS.destroy;
    var pages = ref([]);
    var container = ref(null);
    var viewer = ref(null);
    var _usePDFSize = usePDFSize(pdf, {
        width: refProps.width,
        height: refProps.height
      }),
      scale = _usePDFSize.scale,
      innerWidth = _usePDFSize.width,
      innerHeight = _usePDFSize.height,
      setPDFSizes = _usePDFSize.setPDFSizes,
      setScale = _usePDFSize.setScale,
      isZoomApplied = _usePDFSize.isZoomApplied;
    usePinchZoom({
      container: container,
      content: viewer,
      onPinch: setScale
    });
    useScrollZoom({
      target: container,
      onZoom: setScale
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return load(props.src);
          case 2:
            pages.value = new Array(pdf.value.numPages).fill(0).map(function (_, index) {
              return ++index;
            });
            _context.next = 5;
            return setPDFSizes();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onBeforeUnmount(function () {
      destroyPDF();
    });
    expose({
      zoom: setScale,
      isZoomApplied: isZoomApplied
    });
    return {
      scale: scale,
      pdf: pdf,
      pages: pages,
      innerWidth: innerWidth,
      innerHeight: innerHeight,
      container: container,
      viewer: viewer
    };
  }
});